// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../js/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../js/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProseMirror {
    min-height: 300px;
    max-height: 300px;
    overflow-y: auto;
    padding: 1rem;
}

    /* typography */
    .ProseMirror p {
        font-family: 'Helvetica';
        color: #000000;
        line-height: 1.4;
        font-size: 16px;
    }

.tiptap p {
    font-size: 16px;
}

.tiptap strong {
    font-weight: bold;
}

.tiptap p {
    margin: 0;
}

.tiptap blockquote {
    border-left: 3px solid var(--bs-gray);
    margin: 1.5rem 0;
    padding-left: 1rem;
}

.tiptap pre {
    background: var(--bs-gray);
    border-radius: 0.5rem;
    color: var(--bs-white);
    font-family: 'JetBrainsMono', monospace;
    margin: 1.5rem 0;
    padding: 0.75rem 1rem;
}

.tiptap code {
    background: none;
    color: inherit;
    font-size: 0.8rem;
    padding: 0;
}

/* table */
.tiptap .tableWrapper {
    margin: 1.5rem 0;
    display: block;
    max-width: 100%;
}

.tiptap table {
    border-collapse: collapse;
    width: 100%;
}

    .tiptap table th,
    .tiptap table td {
        padding: 0.5rem;
        border: 1px solid #000000;
        position: relative;
        min-height: 5rem;
        min-width: 5rem;
    }

.tiptap .selectedCell {
    position: relative;
    background-color: rgba(0, 123, 255, 0.1);
    border: 2px solid #007bff;
}

    .tiptap .selectedCell::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 123, 255, 0.1);
        pointer-events: none;
        z-index: 1;
    }

.tiptap .column-resize-handle {
    position: absolute;
    background-color: #007bff;
    cursor: col-resize;
    bottom: -2px;
    right: -2px;
    top: 0;
    width: 4px;
    transition: opacity 0.3s ease;
}

.tiptap .resize-cursor {
    cursor: col-resize;
    cursor: ew-resize;
}

.tiptap td:hover .column-resize-handle,
.tiptap th:hover .column-resize-handle {
    opacity: 1;
}

.tiptap .column-resize-handle.active {
    opacity: 1;
    background-color: #0056b3;
}

.tiptap table td:hover,
th:hover {
    background-color: rgba(0, 123, 255, 0.05);
}

/* invisible characters */
.invisible-character {
    opacity: 0.5;
    position: relative;
    pointer-events: none;
    color: black;
    display: inline;
}

.invisible-space::before {
    content: '·';
    position: absolute;
    top: 0;
    left: 0;
}

.invisible-newline::before {
    content: '↵';
    position: absolute;
    top: 0;
    left: 0;
}

.invisible-paragraph::after {
    content: '¶';
    position: absolute;
    right: -1ch;
    top: 0;
}

/* video */
.video-wrapper {
    display: inline-block;
    position: relative;
    max-width: 100%;
    vertical-align: middle;
}

    .video-wrapper video {
        display: block;
        max-width: 100%;
        height: auto;
        object-fit: contain;
        cursor: pointer;
        user-select: none;
        pointer-events: none;
    }

    .video-wrapper.ProseMirror-selectednode {
        outline: 2px solid #4a9eff;
        outline-offset: 2px;
    }

/* div */
.div-node-view {
    border: 2px solid #646ECB;
    border-radius: 0.5rem;
    position: relative;
    min-height: 2rem;
}

    .div-node-view label {
        background-color: #646ECB;
        border-radius: 0 0 0.5rem 0;
        color: white;
        font-size: 0.75rem;
        font-weight: bold;
        padding: 0.25rem 0.5rem;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
    }

    .div-node-view button {
        position: absolute;
        background-color: #646ECB;
        border-radius: 0 0 0 0.5rem;
        color: white;
        font-size: 0.75rem;
        font-weight: bold;
        padding: 0.25rem 0.5rem;
        top: 0;
        right: 0;
        z-index: 10;
    }

        .div-node-view button.div-settings-button:hover {
            background-color: #646ECB !important;
            color: white !important
        }

    .div-node-view .div-node-view-content {
        margin-left: 2.1rem;
        margin-right: 2.1rem;
        z-index: 1;
    }
`, "",{"version":3,"sources":["webpack://./../css/tiptap.editor.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;IAEI,eAAe;IACf;QACI,wBAAwB;QACxB,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;AAEJ;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,sBAAsB;IACtB,uCAAuC;IACvC,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,UAAU;AACd;;AAEA,UAAU;AACV;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;IAEI;;QAEI,eAAe;QACf,yBAAyB;QACzB,kBAAkB;QAClB,gBAAgB;QAChB,eAAe;IACnB;;AAEJ;IACI,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;AAC7B;;IAEI;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,SAAS;QACT,wCAAwC;QACxC,oBAAoB;QACpB,UAAU;IACd;;AAEJ;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,MAAM;IACN,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;;IAEI,yCAAyC;AAC7C;;AAEA,yBAAyB;AACzB;IACI,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;IACpB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;AACX;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;AAEA,UAAU;AACV;IACI,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;AAC1B;;IAEI;QACI,cAAc;QACd,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;IACvB;;AAEJ,QAAQ;AACR;IACI,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;AACpB;;IAEI;QACI,yBAAyB;QACzB,2BAA2B;QAC3B,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,uBAAuB;QACvB,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,yBAAyB;QACzB,2BAA2B;QAC3B,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,uBAAuB;QACvB,MAAM;QACN,QAAQ;QACR,WAAW;IACf;;QAEI;YACI,oCAAoC;YACpC;QACJ;;IAEJ;QACI,mBAAmB;QACnB,oBAAoB;QACpB,UAAU;IACd","sourcesContent":[".ProseMirror {\r\n    min-height: 300px;\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n    padding: 1rem;\r\n}\r\n\r\n    /* typography */\r\n    .ProseMirror p {\r\n        font-family: 'Helvetica';\r\n        color: #000000;\r\n        line-height: 1.4;\r\n        font-size: 16px;\r\n    }\r\n\r\n.tiptap p {\r\n    font-size: 16px;\r\n}\r\n\r\n.tiptap strong {\r\n    font-weight: bold;\r\n}\r\n\r\n.tiptap p {\r\n    margin: 0;\r\n}\r\n\r\n.tiptap blockquote {\r\n    border-left: 3px solid var(--bs-gray);\r\n    margin: 1.5rem 0;\r\n    padding-left: 1rem;\r\n}\r\n\r\n.tiptap pre {\r\n    background: var(--bs-gray);\r\n    border-radius: 0.5rem;\r\n    color: var(--bs-white);\r\n    font-family: 'JetBrainsMono', monospace;\r\n    margin: 1.5rem 0;\r\n    padding: 0.75rem 1rem;\r\n}\r\n\r\n.tiptap code {\r\n    background: none;\r\n    color: inherit;\r\n    font-size: 0.8rem;\r\n    padding: 0;\r\n}\r\n\r\n/* table */\r\n.tiptap .tableWrapper {\r\n    margin: 1.5rem 0;\r\n    display: block;\r\n    max-width: 100%;\r\n}\r\n\r\n.tiptap table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n    .tiptap table th,\r\n    .tiptap table td {\r\n        padding: 0.5rem;\r\n        border: 1px solid #000000;\r\n        position: relative;\r\n        min-height: 5rem;\r\n        min-width: 5rem;\r\n    }\r\n\r\n.tiptap .selectedCell {\r\n    position: relative;\r\n    background-color: rgba(0, 123, 255, 0.1);\r\n    border: 2px solid #007bff;\r\n}\r\n\r\n    .tiptap .selectedCell::after {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        right: 0;\r\n        bottom: 0;\r\n        background-color: rgba(0, 123, 255, 0.1);\r\n        pointer-events: none;\r\n        z-index: 1;\r\n    }\r\n\r\n.tiptap .column-resize-handle {\r\n    position: absolute;\r\n    background-color: #007bff;\r\n    cursor: col-resize;\r\n    bottom: -2px;\r\n    right: -2px;\r\n    top: 0;\r\n    width: 4px;\r\n    transition: opacity 0.3s ease;\r\n}\r\n\r\n.tiptap .resize-cursor {\r\n    cursor: col-resize;\r\n    cursor: ew-resize;\r\n}\r\n\r\n.tiptap td:hover .column-resize-handle,\r\n.tiptap th:hover .column-resize-handle {\r\n    opacity: 1;\r\n}\r\n\r\n.tiptap .column-resize-handle.active {\r\n    opacity: 1;\r\n    background-color: #0056b3;\r\n}\r\n\r\n.tiptap table td:hover,\r\nth:hover {\r\n    background-color: rgba(0, 123, 255, 0.05);\r\n}\r\n\r\n/* invisible characters */\r\n.invisible-character {\r\n    opacity: 0.5;\r\n    position: relative;\r\n    pointer-events: none;\r\n    color: black;\r\n    display: inline;\r\n}\r\n\r\n.invisible-space::before {\r\n    content: '·';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.invisible-newline::before {\r\n    content: '↵';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n}\r\n\r\n.invisible-paragraph::after {\r\n    content: '¶';\r\n    position: absolute;\r\n    right: -1ch;\r\n    top: 0;\r\n}\r\n\r\n/* video */\r\n.video-wrapper {\r\n    display: inline-block;\r\n    position: relative;\r\n    max-width: 100%;\r\n    vertical-align: middle;\r\n}\r\n\r\n    .video-wrapper video {\r\n        display: block;\r\n        max-width: 100%;\r\n        height: auto;\r\n        object-fit: contain;\r\n        cursor: pointer;\r\n        user-select: none;\r\n        pointer-events: none;\r\n    }\r\n\r\n    .video-wrapper.ProseMirror-selectednode {\r\n        outline: 2px solid #4a9eff;\r\n        outline-offset: 2px;\r\n    }\r\n\r\n/* div */\r\n.div-node-view {\r\n    border: 2px solid #646ECB;\r\n    border-radius: 0.5rem;\r\n    position: relative;\r\n    min-height: 2rem;\r\n}\r\n\r\n    .div-node-view label {\r\n        background-color: #646ECB;\r\n        border-radius: 0 0 0.5rem 0;\r\n        color: white;\r\n        font-size: 0.75rem;\r\n        font-weight: bold;\r\n        padding: 0.25rem 0.5rem;\r\n        position: absolute;\r\n        top: 0;\r\n        left: 0;\r\n        z-index: 10;\r\n    }\r\n\r\n    .div-node-view button {\r\n        position: absolute;\r\n        background-color: #646ECB;\r\n        border-radius: 0 0 0 0.5rem;\r\n        color: white;\r\n        font-size: 0.75rem;\r\n        font-weight: bold;\r\n        padding: 0.25rem 0.5rem;\r\n        top: 0;\r\n        right: 0;\r\n        z-index: 10;\r\n    }\r\n\r\n        .div-node-view button.div-settings-button:hover {\r\n            background-color: #646ECB !important;\r\n            color: white !important\r\n        }\r\n\r\n    .div-node-view .div-node-view-content {\r\n        margin-left: 2.1rem;\r\n        margin-right: 2.1rem;\r\n        z-index: 1;\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
